import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { NavController } from "@ionic/angular";
import { environment } from '@envs/environment';
import { AlertService } from "./alert.service";

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService {

    constructor(
        private _alert: AlertService,
        private _nav: NavController,
    ) {
    }

    async handle(e: any, customMessage: string = null) {
        await this._handle(e, customMessage);
    }

    private async _handle(e: any, customMessage: string = null) {
        if (!environment.production) console.log(e);

        if (customMessage) {
            await this._alert.warn(customMessage);
            return;
        }

        const type = typeof e;

        if (type === 'string') {
            await this._handleString(e);
        } else {
            await this._handleObject(e);
        }
    }

    private async _handleObject(e: HttpErrorResponse): Promise<void> {
        const isValidationError = !!(e.error as ProblemDetail)?.detail;

        if (isValidationError) {
            await this._alert.warn(e.error.detail);
            return;
        } else {
            await this._alert.warn('An error occurred. Please try again later.');
        }
    }

    private async _handleString(e: string): Promise<void> {
        await this._alert.warn(e);
    }
}

interface ProblemDetail {
    type: string;
    title: string;
    status: number;
    detail: string;
    instance: string;
    errors: Record<string, string[]>;
}
